import { formatParams } from 'src/utils/format-params';
import { GetTaxCertificateListPayload } from 'src/redux/slices/purchase-order/tax-certificate/types';

export function formatTaxCertificateListParams(
  params: GetTaxCertificateListPayload
): URLSearchParams {
  return formatParams(params, [
    'supplier_id',
    'period_from',
    'period_to',
    'date_created_from',
    'date_created_to',
    'page'
  ]);
}
